import { render } from "./Regsiter.vue?vue&type=template&id=e7390368"
import script from "./Regsiter.vue?vue&type=script&lang=js"
export * from "./Regsiter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__